export const focusTemplateItemField = (templateItemId, field) => {
  const target = document.getElementById(`${field}-${templateItemId}`);
  if (target) {
    target.focus();
  }
};
